import React from "react";
import { apiWaOrder } from "@/lib/api";
import { MessageCircle } from "lucide-react";
import * as W from "@/lib/waktu";

// F1.5-L: WhatsApp messages of one order for the cashier/owner — status, and
// the wa.me link to send the same text by hand when sending failed.
const KEJADIAN = { ORDER_BARU: "Order baru", PEMBAYARAN: "Pembayaran", ACC_LINK: "Link ACC", SIAP_DIAMBIL: "Siap diambil" };
const CLS = { TERKIRIM: "text-emerald-300", SIMULASI: "text-sky-300", ANTRE: "text-slate-300", MENGIRIM: "text-slate-300", GAGAL: "text-red-300" };

export default function WaStatus({ orderId, refreshKey, testid = "wa-status" }) {
  const [rows, setRows] = React.useState(null);
  React.useEffect(() => { if (orderId) apiWaOrder(orderId).then(setRows).catch(() => setRows(null)); }, [orderId, refreshKey]);
  if (!rows?.length) return null;
  return (
    <div data-testid={testid} className="rounded-lg border border-slate-800 bg-slate-950/40 p-2 text-xs space-y-1">
      <div className="flex items-center gap-1 text-slate-400"><MessageCircle size={13} /> Pesan WhatsApp</div>
      {rows.map((p) => (
        <div key={p.id} className="flex flex-wrap items-center gap-2">
          <span className="text-slate-300">{KEJADIAN[p.kejadian] || p.kejadian}</span>
          <span className={`font-mono ${CLS[p.status] || ""}`}>{p.status === "SIMULASI" ? "SIMULASI (tidak dikirim)" : p.status}</span>
          <span className="text-slate-500">{W.waktu(p.dibuat)}</span>
          {p.error && <span className="text-red-300">{p.error}</span>}
          {p.wa_me && p.status !== "TERKIRIM" && <a href={p.wa_me} target="_blank" rel="noopener noreferrer" className="text-emerald-300 hover:underline">kirim manual</a>}
        </div>
      ))}
    </div>
  );
}
